<template>
    <b-button
        variant="primary"
        @click="confirmarAtesto()"
        :disabled="naoPodeAtestar"
        ><i class="fa fa-check-circle-o"></i> Atesto</b-button
    >
</template>

<script>
import AtestosServicos from './AtestosServicos'

export default {
    props: {
        atesto: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAtesto() {
            this.$swal({
                title: 'Atesto',
                html: `Confirma o ATESTO do documento ${this.atesto.documento}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atestar(result.value)
                }
            })
        },

        atestar() {
            this.$store.dispatch('addRequest')
            let atestoDto = {
                idRegistroAtestoPagamento: this.atesto
                    .idRegistroAtestoPagamento,
                comprovacao01: this.atesto.comprovacao01,
                comprovacao02: this.atesto.comprovacao02,
                problemas: this.atesto.problemas,
                avaliacoes: this.atesto.avaliacoes
            }
            AtestosServicos.atestar(atestoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro atualizado com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAtestosAtualizados')
        }
    },

    created() {},

    computed: {
        naoPodeAtestar() {
            let semResposta = this.atesto.avaliacoes.filter(item => {
                return item.respostaId == 0
            })
            let semComprovacao =
                this.atesto.contrato.tipoEspecial &&
                (this.atesto.comprovacao01 == 0 ||
                    this.atesto.comprovacao02 == 0)
            return (
                this.atesto.avaliacoes.length < 2 ||
                semResposta.length > 0 ||
                semComprovacao
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
